<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Daily Report</li>
                </ol>
                <h4 class="main-title mb-0">Daily Report</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header">
                    <h6 class="card-title">Daily Report</h6>
                </div>
                    <div class="card-body">
                        <div class="row g-2">
                            <div class="col-md-4">
                                <label class="form-label">From Date</label><span class="text-danger"> *</span>
                                <input type="date" class="form-control" :class="{ 'is-invalid': errors?.from_date }" :max="today" v-model="report.from_date" />
                                <span v-if="errors?.from_date"><small class="text-danger">{{ errors?.from_date[0] }}</small></span>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label">To Date</label><span class="text-danger"> *</span>
                                <input type="date" class="form-control" :class="{ 'is-invalid': errors?.to_date }" :max="today" v-model="report.to_date" />
                                <span v-if="errors?.to_date"><small class="text-danger">{{ errors?.to_date[0] }}</small></span>
                            </div>
                            <div class="col-md-4">
                                <div style="float:right">
                                    <button type="button" class="btn btn-primary" style="margin-top:2em;margin-right:1em" @click="getDailyReport()"><i class="ri-save-line fs-18 lh-1"></i> Get</button>
                                    <button type="button" class="btn btn-secondary" style="margin-top:2em" @click="downloadDailyReport()"><i class="ri-download-line fs-18 lh-1"></i> Download</button>
                                </div>
                            </div>
                        </div>
                        <div class="row g-2 mt-2" v-if="dates?.length">
                            <div class="col-md-12">
                                <div class="table-responsive table-responsive-sm">
                                    <table class="table table-bordered table-striped table-sm">
                                        <tbody>
                                            <tr>
                                                <th class="sticky-col text-center">Contents</th>
                                                <th class="sticky-col text-center">Total</th>
                                                <th v-for="date, key in dates" :key="key" class="text-center">{{ date }}</th>
                                            </tr>
                                            <tr>
                                                <td class="sticky-col">Containers Reported</td>
                                                <td class="sticky-col text-center">{{ total_containers_recorded }}</td>
                                                <td class="text-center" v-for="cr, key in containers_recorded" :key="key">{{ cr }}</td>
                                            </tr>
                                            <tr>
                                                <td class="sticky-col">Containers Loaded</td>
                                                <td class="sticky-col text-center">{{ total_containers_loaded }}</td>
                                                <td class="text-center" v-for="cl, key in containers_loaded" :key="key">{{ cl }}</td>
                                            </tr>
                                            <tr>
                                                <td class="sticky-col">Containers heldback (No)</td>
                                                <td class="sticky-col text-center">{{ total_containers_heldback }}</td>
                                                <td class="text-center" v-for="reasons, key in containers_heldback" :key="key" width="10%">
                                                    <span v-for="reason, key in reasons" :key="key" style="font-size: 8pt;">{{ reason.reason }}<br></span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td :rowspan="measurements?.length+1">
                                                    Measurement of recd pallet
                                                    <h6 v-for="measurement, key in measurements" :key="key">{{ measurement.pallet_size_name }}</h6>
                                                </td>
                                            </tr>
                                            <tr v-for="measurement, key in measurements" :key="key">
                                                <td class="text-center">{{ measurement.pallet_size_name }}</td>
                                                <td class="text-center" v-for="number_of_pallet, key in measurement.number_of_pallets" :key="key">{{ number_of_pallet }}</td>
                                            </tr>
                                            <tr>
                                                <td :rowspan="pallet_weights?.length+2">
                                                    Pallet Weights
                                                    <h6 v-for="pallet_weight, key in pallet_weights" :key="key">{{ pallet_weight.pallet_size_name }}</h6>
                                                </td>
                                            </tr>
                                            <tr v-for="pallet_weight, key in pallet_weights" :key="key">
                                                <td class="text-center">{{ pallet_weight.pallet_size_name }}</td>
                                                <td class="text-center" v-for="weight, key in pallet_weight.weights" :key="key">{{ weight }}</td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">Avg. Moisture</td>
                                                <td class="text-center" v-for="moisture, key in pallet_moistures" :key="key">{{ moisture }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
export default {
    data(){
        return{
            report:{
                from_date:'',
                to_date:''
            },
            dates:[],
            containers_recorded:[],
            containers_loaded:[],
            containers_heldback:[],
            total_containers_recorded: '',
            total_containers_loaded: '',
            total_containers_heldback:'',
            measurements:[],
            pallet_weights:[],
            pallet_moistures:[],
            today:'',
            errors:[]
        }
    },
    mounted(){
        this.today = moment().format('yyyy-MM-DD')
        this.report.to_date = moment().format('yyyy-MM-DD')
    },
    methods:{
        getDailyReport(){
            let vm = this;
            vm.$store
                .dispatch("post", { uri: "getDailyReport", data: vm.report })
                .then((response) => {
                    vm.dates = response.data.dates
                    vm.containers_heldback = response.data.containers_heldback
                    vm.containers_loaded = response.data.containers_loaded
                    vm.containers_recorded = response.data.containers_recorded
                    vm.total_containers_recorded = response.data.total_containers_recorded
                    vm.total_containers_loaded = response.data.total_containers_loaded
                    vm.total_containers_heldback = response.data.total_containers_heldback
                    vm.measurements = response.data.measurements
                    vm.pallet_weights = response.data.pallet_weights
                    vm.pallet_moistures = response.data.pallet_moistures
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        downloadDailyReport(){
            window.open(this.$store.getters.apiUrl+'downloadDailyReport?from_date='+this.report.from_date+'&to_date='+this.report.to_date)
        },
    }
}
</script>

<style scoped>
.table {
    position: relative;
    overflow-x: auto;
}

.sticky-col {
    position: -webkit-sticky; 
    position: sticky;
    left: 0;
    background-color: white; 
    z-index: 2;
}

.sticky-col + .sticky-col {
    left: 80px; 
    z-index: 3; 
}
</style>